import { UserRolesService } from './../../../shared/services/user-roles.service';
import { orderBy } from 'lodash';
import { PadService } from './../../../shared/services/pad.service';
import { Subscription } from 'rxjs';
import { User } from './../../../shared/models/user.model';
import { UserAuthService } from './../../../shared/services/user-auth.service';
import { Router } from '@angular/router';
import { Helper } from './../../../shared/helpers/helper';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-dashboard-pad',
  templateUrl: './dashboard-pad.component.html',
  styleUrls: ['./dashboard-pad.component.scss']
})
export class DashboardPadComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];

  listPads: any[] = [];

  loading: boolean = false;
  user: User;

  isCarboAdmin: boolean = false;
  isService: boolean = false;
  isOperator: boolean = false;
  searchFormValues: any;
  // Paging
  pagingState = {
    page: 1,
    pageSize: 20,
    collectionSize: 10
  };
  sortState = {
    sortField: '',
    sortType: false
  };

  constructor(
    private userAuthService: UserAuthService,
    private userRolesService: UserRolesService,
    private padService: PadService,
    private router: Router
  ) {
    this.user = this.userAuthService.getUserInfo();
    const userRole = this.userRolesService.toUserRole(this.user);
    this.isCarboAdmin = this.userRolesService.isCarboAdmin(userRole);
  }

  ngOnInit(): void {
    if (this.user && this.user.companyType !== 'Service') {
      this.isService = true;
    }
    if (this.user && this.user.companyType !== 'Operator') {
      this.isOperator = true;
    }
    this.loadData();
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  private loadData(): void {
    this.loading = true;
    this.subscriptions.push(
      this.padService.getListPads(this.searchFormValues, this.pagingState.page, this.pagingState.pageSize, this.sortState.sortField, this.sortState.sortType)
      .subscribe(
        (res) => {
          if (res) {
            this.listPads = orderBy(res.result.items, ['padName'], ['asc']);
            this.pagingState.collectionSize = res.result.totalCount;
          }
          this.loading = false;
        }, (error) => {
          this.loading = false;
        }
      )
    );
  }

  onSearchPads(eventData) {
    this.pagingState.page = 1;
    this.searchFormValues = eventData;
    this.loadData();
  }

  showPadDetails(item: any): void {
    this.router.navigate(['pages', 'pads', `${item.padName}`], {
      queryParams: {
        page: this.pagingState.page
      }
    });
  }

  onSortPadChange(eventData) {
    if (eventData) {
      this.sortState.sortField = eventData.column;
      this.sortState.sortType = eventData.direction === 'asc';
      this.loadData();
    }
  }

  onPageChange(page) {
    this.pagingState.page = page;
    this.loadData();
  }

}
